export const isOidcCallbackStillInUrl = (search: string = window.location.search): boolean => {
    const params = new URLSearchParams(search);
    return params.has("code") || params.has("state") || params.has("session_state");
};
